"use client";

import { FC, PropsWithChildren } from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "@/common/store/redux";
const ReduxProvider: FC<PropsWithChildren> = props => {
  const {
    children
  } = props;
  return <Provider store={store} data-sentry-element="Provider" data-sentry-component="ReduxProvider" data-sentry-source-file="provider.tsx">
      <PersistGate loading={null} persistor={persistor} data-sentry-element="PersistGate" data-sentry-source-file="provider.tsx">
        {children}
      </PersistGate>
    </Provider>;
};
export default ReduxProvider;